/**
 * 云空间上传文件进度列表组件
 */
import React, { useCallback, useRef, useContext } from "react";
import UploadBox from "@/components/UploadBox";
import { joyspaceKey } from "@/components/UploadBox/UploadControl";
import { analysisLog } from "@/utils/logAnalytics";
import { debounce } from "lodash";
import { UploadFile } from "./types";
import events from "../../context/events";
import { ActionType, MenusType } from "../../types";
function JoySpaceUploadBox() {
  const ref = useRef<HTMLDivElement | null>(null);
  const uploadSuccessCallBackFunc = (data: any) => {
    let doUpload = debounce((folderId) => {
      events.emit("list.reload", { folderId, type: ActionType.Page });
      // 上传文件夹时刷新最近列表，folderId不为空时因为上面的刷新可以触发最近列表刷新
      if (folderId) {
        events.emit("list.reload", { key: MenusType.RECENT });
      }
    }, 1000);
    doAnalysisLog({
      status: "成功",
      name: data?.file?.name,
      type: data?.file?.type,
      folderId: data?.file?.folderId
    });
    doUpload(data?.file?.folderId);
  };
  const uploadFailCallBackFunc = (data: any) => {
    doAnalysisLog({
      status: "失败",
      name: data?.file?.name,
      type: data?.file?.type,
      folderId: data?.file?.folderId
    });
  };
  const doAnalysisLog = useCallback(
    (data: { status: string; name: string; type: string; folderId: string }) => {
      const { status, name, type, folderId } = data;
      analysisLog("xtbg_jzb_joyspace_home_1676548210761", "38", "", status, name, folderId, type);
    },
    []
  );

  return (
    <UploadBox
      ref={ref}
      uploadControlName={joyspaceKey}
      toJoysSapce={true}
      headerTitle=""
      // retryLimitCallBackFunc={retryLimitCallBackFunc}
      uploadSuccessCallBackFunc={uploadSuccessCallBackFunc}
      uploadFailCallBackFunc={uploadFailCallBackFunc}
      className="joyspace-upload"
    />
  );
}

export default JoySpaceUploadBox;
